import { camelizeKeys, decamelizeKeys } from 'humps';
import { normalize } from 'normalizr';

import { CALL_API } from 'constants/common';
import { getToken } from 'helpers/auth';

const API_ROOT = 'https://leva-api.codebnb.me/api/v1';

const callApi = async ({ endpoint, schema, body, method = 'GET' }) => {
  const fullUrl = `${API_ROOT + endpoint}/`;

  const stringBody = JSON.stringify(decamelizeKeys(body));

  const headers = { 'content-type': 'application/json' };

  const token = getToken();

  if (token) {
    headers.Authorization = `Token ${token}`;
  }

  const response = await fetch(fullUrl, {
    method,
    body: stringBody,
    headers
  });

  if (!response.ok) {
    throw new Error();
  }

  const json = await response.json();
  const camelized = camelizeKeys(json.results || json);

  return schema ? normalize(camelized, schema) : camelized;
};

export default () => next => async action => {
  const callAPI = action[CALL_API];

  if (typeof callAPI === 'undefined') {
    return next(action);
  }

  const { schema, types, endpoint, method, body } = callAPI;

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL.');
  }

  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected an array of three action types.');
  }

  if (!types.every(type => typeof type === 'string')) {
    throw new Error('Expected action types to be strings.');
  }

  const actionWith = data => {
    const finalAction = Object.assign({}, action, data);
    delete finalAction[CALL_API];
    return finalAction;
  };

  const [requestType, successType, failureType] = types;
  next(actionWith({ type: requestType }));

  try {
    const response = await callApi({ endpoint, method, schema, body });

    return next(
      actionWith({
        response,
        type: successType
      })
    );
  } catch (e) {
    return next(
      actionWith({
        type: failureType,
        error: e.message || 'Something bad happened'
      })
    );
  }
};



// WEBPACK FOOTER //
// ./src/middleware/api.js